import { createTheme } from '@mui/material/styles';
import { colors } from '../styles/colors.js';
import shippoTheme from '../styles/shippoTheme.js';

const toggleButtonThemeInput = {
    palette: {
        primary: {
            main: colors.accent.foreground.success,
            dark: colors.primaryButtonHover,
        },
        secondary: {
            main: colors.secondary,
            dark: colors.secondary,
        },
    },
    components: {
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    '&.MuiToggleButton-secondary': {
                        color: colors.secondary,
                        backgroundColor: colors.white,
                    },
                    '&.MuiToggleButton-secondary.Mui-selected': {
                        color: colors.white,
                        backgroundColor: colors.secondary,
                    },
                },
            },
        },
    },
};
var toggleButtonTheme = createTheme(shippoTheme, toggleButtonThemeInput);

export { toggleButtonTheme as default, toggleButtonThemeInput };
//# sourceMappingURL=ToggleButton.theme.js.map
